import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import e from "../../../core/Logger.js";
import { all as r, eachAlways as t } from "../../../core/promiseUtils.js";
import a from "../../../layers/FeatureLayer.js";
import { applyTextFormattingHTML as i, htmlEntities as s } from "./featureUtils.js";
var n = ["$datastore", "$map", "$layer", "$aggregatedfeatures"],
    o = "esri.widgets.Feature.support.arcadeFeatureUtils",
    c = e.getLogger(o);

function p(e) {
  return "string" == typeof e ? i(s(e)) : Array.isArray(e) ? l(e) : "esri.arcade.Dictionary" === (null == e ? void 0 : e.declaredClass) ? u(e) : e;
}

function l(e) {
  return "<ul class=\"esri-widget__list\">".concat(e.map(function (e) {
    return "<li>".concat("string" == typeof e ? i(s(e)) : e, "</li>");
  }).join(""), "</ul>");
}

function u(e) {
  return "<table class=\"esri-widget__table\">".concat(e.keys().map(function (r) {
    var t = e.field(r);
    return "<tr><th>".concat(r, "</th><td>").concat("string" == typeof t ? i(s(t)) : t, "</td></tr>");
  }).join(""), "</table>");
}

function f(_ref) {
  var e = _ref.aggregatedFeatures,
      r = _ref.arcadeUtils,
      t = _ref.featureSetVars,
      i = _ref.context,
      s = _ref.viewInfo,
      n = _ref.map,
      o = _ref.graphic,
      c = _ref.interceptor;
  t.forEach(function (t) {
    var p = t.toLowerCase(),
        l = {
      map: n,
      spatialReference: s.sr,
      interceptor: c
    };

    if ("$map" === p && (i.vars[p] = r.convertMapToFeatureSetCollection(l)), "$layer" === p && (i.vars[p] = r.convertFeatureLayerToFeatureSet({
      layer: o.sourceLayer,
      spatialReference: s.sr,
      interceptor: c
    })), "$datastore" === p && (i.vars[p] = r.convertServiceUrlToWorkspace({
      url: o.sourceLayer.url,
      spatialReference: s.sr,
      interceptor: c
    })), "$aggregatedfeatures" === p) {
      var _t = o.layer,
          _n = _t.fields,
          _l = _t.objectIdField,
          _u = _t.geometryType,
          _f = _t.spatialReference,
          _d = _t.displayField,
          _g = new a(_objectSpread(_objectSpread({
        fields: _n,
        objectIdField: _l,
        geometryType: _u,
        spatialReference: _f,
        displayField: _d
      }, "feature" === _t.type ? {
        templates: _t.templates,
        typeIdField: _t.typeIdField,
        types: _t.types
      } : null), {}, {
        source: e
      }));

      i.vars[p] = r.convertFeatureLayerToFeatureSet({
        layer: _g,
        spatialReference: s.sr,
        interceptor: c
      });
    }
  });
}

function d() {
  return import("../../../support/arcadeUtils.js");
}

function g(_x) {
  return _g2.apply(this, arguments);
}

function _g2() {
  _g2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
    var e, r, t, a, i, s, _yield$i$queryFeature, n;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            e = _ref2.graphic, r = _ref2.view;
            t = e.isAggregate, a = e.layer;

            if (!(!t || !a || "2d" !== (null == r ? void 0 : r.type))) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", []);

          case 4:
            _context.next = 6;
            return r.whenLayerView(a);

          case 6:
            i = _context.sent;

            if (!(!i.createQuery || !i.queryFeatures)) {
              _context.next = 9;
              break;
            }

            return _context.abrupt("return", []);

          case 9:
            s = i.createQuery();
            s.aggregateIds = [e.getObjectId()];
            _context.next = 13;
            return i.queryFeatures(s);

          case 13:
            _yield$i$queryFeature = _context.sent;
            n = _yield$i$queryFeature.features;
            return _context.abrupt("return", n);

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _g2.apply(this, arguments);
}

function y(_x2) {
  return _y.apply(this, arguments);
}

function _y() {
  _y = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
    var e, t, a, i, s, o, p, l, u, _yield$r, _yield$r2, d, y, m, w;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            e = _ref3.expressionInfo, t = _ref3.arcadeUtils, a = _ref3.interceptor, i = _ref3.spatialReference, s = _ref3.map, o = _ref3.graphic, p = _ref3.view;

            if (!(!e || !e.expression)) {
              _context2.next = 3;
              break;
            }

            return _context2.abrupt("return", null);

          case 3:
            l = t.createSyntaxTree(e.expression);
            u = n.filter(function (e) {
              return t.hasVariable(l, e);
            });
            _context2.next = 7;
            return r([g({
              graphic: o,
              view: p
            }), t.loadScriptDependencies(l, !0, u)]);

          case 7:
            _yield$r = _context2.sent;
            _yield$r2 = _slicedToArray(_yield$r, 1);
            d = _yield$r2[0];
            y = t.getViewInfo({
              spatialReference: i
            });
            m = t.createExecContext(o, y);
            m.interceptor = a, m.useAsync = !0, f({
              aggregatedFeatures: d,
              arcadeUtils: t,
              featureSetVars: u,
              context: m,
              viewInfo: y,
              map: s,
              graphic: o,
              interceptor: a
            });
            w = t.createFunction(l, m);
            return _context2.abrupt("return", t.executeAsyncFunction(w, m).catch(function (r) {
              return c.error("arcade-execution-error", {
                error: r,
                graphic: o,
                expressionInfo: e
              });
            }));

          case 15:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _y.apply(this, arguments);
}

function m(_x3) {
  return _m.apply(this, arguments);
}

function _m() {
  _m = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref4) {
    var e, r, a, i, s, n, o, c, _iterator, _step, _t3, l, u, _t2;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            e = _ref4.expressionInfos, r = _ref4.spatialReference, a = _ref4.graphic, i = _ref4.interceptor, s = _ref4.map, n = _ref4.view;

            if (!(!e || !e.length)) {
              _context3.next = 3;
              break;
            }

            return _context3.abrupt("return", {});

          case 3:
            _context3.next = 5;
            return d();

          case 5:
            o = _context3.sent;
            c = {};
            _iterator = _createForOfIteratorHelper(e);

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                _t3 = _step.value;
                c["expression/".concat(_t3.name)] = y({
                  expressionInfo: _t3,
                  arcadeUtils: o,
                  interceptor: i,
                  spatialReference: r,
                  map: s,
                  graphic: a,
                  view: n
                });
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }

            _context3.next = 11;
            return t(c);

          case 11:
            l = _context3.sent;
            u = {};

            for (_t2 in l) {
              u[_t2] = p(l[_t2].value);
            }

            return _context3.abrupt("return", u);

          case 15:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _m.apply(this, arguments);
}

export { y as createCompiledExpression, m as createCompiledExpressions, d as loadArcadeUtils };